import "./devops-and-cyber-security.css";
import { useNavigate } from "react-router-dom";
import Timeline from "../../../components/timeline/timeline-comp";
import { useTranslation } from "react-i18next";

export default function DevOpsAndCyberSecurity() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const goToContact = () => {
    navigate("/contact-us");
  };

  const goToAbout = () => {
    navigate("/about-us");
  };

const timelineData = [
  {
    date: "01",
    title: "Accelerated Deployment",
    content: "Faster and more reliable software delivery through CI/CD automation.",
  },
  {
    date: "02",
    title: "Enhanced Security Posture",
    content: "Proactive threat detection, vulnerability management, and compliance enforcement.",
  },
  {
    date: "03",
    title: "Improved Collaboration",
    content: "Seamless integration between development and operations teams for greater efficiency.",
  },
  {
    date: "04",
    title: "Scalability & Resilience",
    content: "Automated infrastructure scaling and robust recovery mechanisms ensure service continuity.",
  },
  {
    date: "05",
    title: "Continuous Monitoring",
    content: "Real-time monitoring and incident response to maintain system health and security.",
  },
];



const challenges = [
  {
    number: "01",
    text: "Lack of integration between development and security teams, leading to slower delivery and vulnerabilities.",
  },
  {
    number: "02",
    text: "Inconsistent security practices across CI/CD pipelines and cloud environments.",
  },
  {
    number: "03",
    text: "Difficulty in maintaining compliance, monitoring threats, and ensuring continuous protection.",
  },
];



const cards = [
  {
    icon: "fa-solid fa-diagram-project",
    title: "Integrating DevOps & Security",
    text: "Integrating DevOps and cyber security practices.",
  },
  {
    icon: "fa-solid fa-lock",
    title: "Secure Automated Development",
    text: "Secure development methodologies, automated deployment, and continuous monitoring.",
  },
  {
    icon: "fa-solid fa-bolt",
    title: "Faster, Streamlined Security",
    text: "Faster time-to-market, improved security posture, and streamlined operations.",
  },
];



  return (
    <div className="main-container">
      {/* main image section */}
      <section className="main-image-section devops-main-section">
        <div className="main-image-dark-effect">
          <h6 className="sub-container-sub-heading">{t("Services")}</h6>
          <h1 className="sub-container-heading">{t("DevOps and Cyber Security")}</h1>
          <p className="sub-container-desc">
            {t("DevOps and cybersecurity together enable faster delivery, automation, and built-in protection against threats ensuring secure, agile, and resilient digital operations.")}
          </p>
          <div className="main-img-container-buttons">
            <button
              type="button"
              className="img-contact-btn common-btn-styles"
              onClick={goToContact}
            >
              {t("Contact Us")}
            </button>
            <button
              type="button"
              className="img-about-btn common-btn-styles"
              onClick={goToAbout}
            >
              {t("About Us")}
            </button>
          </div>
        </div>
      </section>

      {/* service overview section */}
      <section className="service-overview">
        <div className="service-overview-width sub-container">
          <div>
            <h1 className="sub-container-heading">{t("Service Overview")}</h1>
          </div>

          <div className="service-img-container">
            <div className="service-image">
              <img
                src="/assets/images/devops-service-overview.webp"
                alt="Devops Service Overview"
              />
            </div>

            {/* Right Content */}
            <div className="service-content">
              <p>
                {t("We integrate DevOps and Cybersecurity to build secure, agile, and resilient systems, ensuring faster delivery, continuous monitoring, and proactive threat prevention for confident innovation.")}
              </p>
                <ul>
                    <li>
                        <i className="fa-solid fa-angles-right"></i>
                        {t("Comprehensive DevOps and cybersecurity solutions to safeguard digital assets.")}
                    </li>
                    <li>
                        <i className="fa-solid fa-angles-right"></i>
                        {t("Industry best practices and advanced technologies for efficient, secure, and agile operations.")}
                    </li>
                    <li>
                        <i className="fa-solid fa-angles-right"></i>
                        {t("Continuous monitoring and automation to enhance system resilience and performance.")}
                    </li>
                </ul>

            </div>
          </div>
        </div>
      </section>

      {/*challenges secton*/}
      <section className="challenges-section sub-container">
        <h2 className="sub-container-heading">{t("Challenges")}</h2>
        <p className="sub-container-desc">
            {t("Common DevOps and Cyber Security challenges organizations face in today’s digital landscape.")}       
        </p>
        <div className="challenges-container">
          {challenges.map((item, index) => (
            <div
              className="challenge-box"
              key={index}
              data-number={item.number}
            >
              <p className="challenge-text">{t(item.text)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* how are we solving section */}
      <section className="solving-section">
        <div className="solving-section-container sub-container">
          <h1 className="sub-container-heading">How Are We Solving</h1>
          <p className="sub-container-desc">
            {t("We deliver DevOps and cybersecurity solutions that boost security, accelerate development, and enhance operational efficiency through automation and optimization.")}
          </p>
          <div className="solving-cards">
            {cards.map((card, index) => (
              <div className="solving-card" key={index}>
                <div className="icon-wrapper">
                  <i className={card.icon}></i>
                </div>
                <h3>{t(card.title)}</h3>
                <p>{t(card.text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* benefits section */}
      <section className="benefits-section sub-container">
        <h1 className="sub-container-heading">{t("Benefits")}</h1>
        <p className="sub-container-desc">
            {t("With the quality and approach, we would be delivering the best of what you’d need in consulting, suggesting, providing right solutions thus yielding best benefits for your organizations productivity.")}
        </p>
        <div>
          <Timeline timelineData={timelineData} />
        </div>
      </section>
    </div>
  );
}